import { mutationOptions, useQueryClient } from '@tanstack/react-query';

import {
    FEES_SETTINGS_TYPE,
    SUPERBILL_SETTINGS_TYPE,
} from '../model/client-billing-settings.schemas';
import type {
    FeesSettingsPatch,
    SuperbillSettingsPatch,
} from '../model/client-billing-settings.types';
import { clientBillingSettingsApi } from './client-billing-settings.api';
import { feesSettingsOptions, superbillSettingsOptions } from './client-billing-settings.queries';

export function useUpdateSuperbillSettingsOptions() {
    const queryClient = useQueryClient();
    return mutationOptions({
        mutationFn: (patch: SuperbillSettingsPatch) =>
            clientBillingSettingsApi.updateByType(SUPERBILL_SETTINGS_TYPE, patch),
        onSuccess: async (_, patch) => {
            await queryClient.cancelQueries({ queryKey: superbillSettingsOptions().queryKey });
            queryClient.setQueryData(superbillSettingsOptions().queryKey, (previous) => {
                if (!previous) return previous;
                return { type: SUPERBILL_SETTINGS_TYPE, value: { ...previous.value, ...patch } };
            });
        },
    });
}

export function useUpdateFeesSettingsOptions() {
    const queryClient = useQueryClient();
    return mutationOptions({
        mutationFn: (patch: FeesSettingsPatch) =>
            clientBillingSettingsApi.updateByType(FEES_SETTINGS_TYPE, patch),
        onSuccess: async (_, patch) => {
            await queryClient.cancelQueries({ queryKey: feesSettingsOptions().queryKey });
            queryClient.setQueryData(feesSettingsOptions().queryKey, (previous) => {
                if (!previous) return previous;
                return { type: FEES_SETTINGS_TYPE, value: { ...previous.value, ...patch } };
            });
        },
    });
}
